import type { ReactNode } from 'react';
import React, { useState } from 'react';

import { Provider, defaultValue } from 'src/shared/hooks/useEphemeralEmail';

interface EphemeralEmailProps {
  children: ReactNode;
}

const EphemeralEmail = ({ children }: EphemeralEmailProps) => {
  const [email, setEmail] = useState<string | undefined>();

  const clear = () => setEmail(undefined);

  const contextValue = {
    ...defaultValue,
    clear,
    email,
    setEmail,
  };

  return <Provider value={contextValue}>{children}</Provider>;
};

export { EphemeralEmail };
